module.exports = __webpack_public_path__ + "img/laboratorio_3-4_2304.b04d00b9.webp";